module.exports = __webpack_public_path__ + "img/icon_only.3c61af5f.png";